import React from "react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import FloatingWhatsApp from "@/components/FloatingWhatsApp";

const Layout = ({ children }) => {
  return (
    <div className="min-h-screen bg-black text-white bg-grain relative">
      <Header />
      <main className="pt-24 md:pt-28 relative z-10">{children}</main>
      <Footer />
      <FloatingWhatsApp />
    </div>
  );
};

export default Layout;
